import React from "react";
import "./OptionsDialog.scss";
import { Modal } from "react-bootstrap";
import { AspectRatio, assets } from "../api/ReplayVariables";
import { useTranslation } from "react-i18next";
import PerfectScrollbar from "react-perfect-scrollbar";

function OptionsDialog({
  show,
  handleClose,
  ratio,
  selectedBackground,
  selectedTable,
  onBackgroundChange,
  onTableChange,
}) {
  const fontSize = Math.floor(AspectRatio.refFontSize * ratio);

  const backgrounds = [];
  const tables = [];
  Object.keys(assets).forEach((name) => {
    if (name.startsWith("background")) {
      backgrounds.push({
        name: name.replace("background", ""),
        background: assets[name],
      });
    } else {
      tables.push({
        num: parseInt(name.replace("table", "")),
        background: assets[name],
      });
    }
  });
  //console.log("selectedBackground", selectedBackground);

  const { t } = useTranslation();

  return (
    <Modal
      show={show}
      onHide={handleClose}
      backdrop
      keyboard={false}
      centered
      animation={false}
      dialogClassName="modal-90w"
    >
      <Modal.Header closeButton closeLabel={false}>
        <Modal.Title
          style={{
            fontSize: fontSize + "px",
          }}
        >
          {t("options")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex flex-row">
          <div className="w-50-p backgrounds">
            <PerfectScrollbar
              style={{
                maxHeight: "calc(100vh - 210px)",
                overflowY: "auto",
              }}
            >
              {backgrounds.map((background) => (
                <img
                  key={background.background}
                  src={background.background}
                  className={
                    selectedBackground === background.name
                      ? "background selected"
                      : "background"
                  }
                  alt=""
                  onClick={() => {
                    onBackgroundChange(background.name);
                  }}
                  style={{
                    float: "center",
                  }}
                />
              ))}
            </PerfectScrollbar>
          </div>
          <div className="w-50-p tables">
            <PerfectScrollbar
              style={{
                maxHeight: "calc(100vh - 210px)",
                overflowY: "auto",
              }}
            >
              {tables.map((_table) => (
                <img
                  key={"table" + _table.num}
                  src={assets["table" + _table.num]}
                  className={
                    selectedTable === _table.num
                      ? "background selected"
                      : "background"
                  }
                  alt=""
                  onClick={() => {
                    onTableChange(_table.num);
                  }}
                  style={{
                    float: "center",
                  }}
                />
              ))}
            </PerfectScrollbar>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default OptionsDialog;
